import { IMAGE_LOADER, ImageLoaderConfig } from "@angular/common";
import { ChangeDetectionStrategy, Component, OnInit } from "@angular/core";
import { UIState } from "@dtm-frontend/shared/ui";
import { FunctionUtils } from "@dtm-frontend/shared/utils";
import { Store } from "@ngxs/store";
import { BROCHURE_FILE } from "../kpo.data";
import resultsData from "./results.json";
import { ResultsJsonData } from "./results.types";

interface Results {
    region: {
        name: string;
        regionCode: string;
        entity: {
            name: string;
            area: string;
            leader: string;
        }[];
    }[];
}

@Component({
    selector: "dtm-main-page-lib-kpo-results",
    templateUrl: "./results.component.html",
    styleUrls: ["../../shared.scss", "./results.component.scss"],
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [
        {
            provide: IMAGE_LOADER,
            useValue: (config: ImageLoaderConfig) => {
                const fileName = config.src;
                const fileExtensionMatch = fileName.match(/\.(\w+)$/);
                const fileExtension = fileExtensionMatch?.[1];

                const DOUBLE_SIZE_WIDTH = 200;
                if (!fileExtension || !config.width || config.width !== DOUBLE_SIZE_WIDTH) {
                    return fileName;
                }

                return fileName.replace(`.${fileExtension}`, `@2x.${fileExtension}`);
            },
        },
    ],
})
export class ResultsComponent implements OnInit {
    protected readonly activeLanguage$ = this.store.select(UIState.activeLanguage);
    protected data: Results | undefined;
    protected readonly displayedColumns = ["name", "area", "leader"];
    protected readonly BROCHURE_FILE = BROCHURE_FILE;

    private jsonData: ResultsJsonData = resultsData as ResultsJsonData;

    constructor(private readonly store: Store) {}

    public ngOnInit(): void {
        this.data = this.transformData();
    }

    private transformData(): Results {
        const transformedData: Results = {
            region: [],
        };

        Object.keys(this.jsonData.regiony).forEach((regionKey) => {
            const regionKeyTyped = regionKey as keyof ResultsJsonData["regiony"];
            const regionName = this.jsonData.regiony[regionKeyTyped];
            const regionAreas = this.jsonData.obszaryWgRegionow[regionKeyTyped] || [];

            const regionData = {
                name: regionName ?? "",
                regionCode: regionKeyTyped,
                entity: regionAreas
                    .map((areaId) => {
                        const area = this.jsonData.obszary.find((a) => a.id === areaId);
                        if (!area) {
                            return;
                        }

                        return {
                            name: area.nazwa,
                            area: area.powierzchnia,
                            leader: area.lider,
                        };
                    })
                    .filter(FunctionUtils.isTruthy),
            };

            transformedData.region.push(regionData);
        });

        return transformedData;
    }
}
